angular.module('core')
  .service('graduationApi', ['cancelableResourceFactory', function ($cancelableResourceFactory) {
      var graduationMapping = function(body) {
        try {
          var parsed = JSON.parse(body);
          parsed.type = 'primaryGraduation';
          return parsed;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return {};
        }
      };

      var PrimaryGraduation = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/primary_graduation', {
          id: '@id'
        }, {
          get: {
            url: '/m/classroom/:id/primary_graduation',
            method: 'GET',
            transformResponse: graduationMapping
          }
        }
      );

      var getPrimaryGraduation = function(cid) {
        var resource = PrimaryGraduation.get({id: cid});
        return resource.$promise;
      };

      var savePrimaryGraduation = function(item, success, error) {
        var resource = new PrimaryGraduation(item);
        resource.$save([], success, error);
      };

      return {getPrimaryGraduation: getPrimaryGraduation,
              savePrimaryGraduation: savePrimaryGraduation};
    }]);
